import { ApiError, } from "@zgame/protocol";
/** Worker HTTP API 客户端（技术方案 §7.2）。 */
export class RoomApiClient {
    #base;
    #fetch;
    constructor(opts = {}) {
        this.#base = (opts.baseUrl ?? "").replace(/\/$/, "");
        this.#fetch = opts.fetchImpl ?? ((...args) => fetch(...args));
    }
    createRoom(req, hostId) {
        return this.#post("/api/rooms", req, { "X-Host-Id": hostId });
    }
    joinRoom(roomId, req) {
        return this.#post(`/api/rooms/${encodeURIComponent(roomId)}/join`, req);
    }
    /** 房间状态迁移（仅 hostToken）。 */
    setStatus(roomId, token, status) {
        return this.#post(`/api/rooms/${encodeURIComponent(roomId)}/status`, { status }, this.#auth(token));
    }
    heartbeat(roomId, token) {
        return this.#post(`/api/rooms/${encodeURIComponent(roomId)}/heartbeat`, {}, this.#auth(token));
    }
    getRoom(roomId, token) {
        return this.#get(`/api/rooms/${encodeURIComponent(roomId)}`, this.#auth(token));
    }
    /** 轮询：一次性返回房间状态 + 信令消息（D1 增补端点）。 */
    sync(roomId, token, after) {
        return this.#get(`/api/rooms/${encodeURIComponent(roomId)}/sync?after=${after}`, this.#auth(token));
    }
    signal(roomId, token, message) {
        return this.#post(`/api/rooms/${encodeURIComponent(roomId)}/signal`, message, this.#auth(token));
    }
    leave(roomId, token) {
        return this.#post(`/api/rooms/${encodeURIComponent(roomId)}/leave`, {}, this.#auth(token));
    }
    closeRoom(roomId, token) {
        return this.#request(`/api/rooms/${encodeURIComponent(roomId)}`, { method: "DELETE" }, this.#auth(token));
    }
    #auth(token) {
        return { Authorization: `Bearer ${token}` };
    }
    async #get(path, headers) {
        return this.#request(path, { method: "GET", headers });
    }
    async #post(path, body, headers = {}) {
        return this.#request(path, {
            method: "POST",
            headers: { "Content-Type": "application/json", ...headers },
            body: JSON.stringify(body ?? {}),
        });
    }
    async #request(path, init, extra) {
        const res = await this.#fetch(`${this.#base}${path}`, {
            ...init,
            headers: { ...init.headers, ...(extra ?? {}) },
        });
        const text = await res.text();
        let data = null;
        try {
            data = text ? JSON.parse(text) : null;
        }
        catch {
            data = null;
        }
        if (!res.ok) {
            const err = (data ?? {});
            throw new ApiError(err.error ?? "BAD_REQUEST", res.status, err.message ?? res.statusText);
        }
        return data;
    }
}
//# sourceMappingURL=api.js.map